export default "__VITE_ASSET__lf4oPMWx__"